<template>
    <div class="cert-empty">
        <span class="cert-empty__icon" aria-hidden="true">
            <v-icon size="34">{{ error ? 'mdi-alert-circle-outline' : 'mdi-certificate-outline' }}</v-icon>
        </span>
        <h2>{{ title }}</h2>
        <p v-if="hint">{{ hint }}</p>
        <button v-if="showClear" type="button" class="cert-empty__btn" @click="$emit('clear')">
            {{ $t('student.certificates.clearFilters') }}
        </button>
        <button v-else-if="error" type="button" class="cert-empty__btn" @click="$emit('retry')">
            {{ $t('common.retry') }}
        </button>
    </div>
</template>

<script>
    export default {
        name: 'CertificateEmptyState',
        props: {
            title: { type: String, required: true },
            hint: { type: String, default: '' },
            showClear: { type: Boolean, default: false },
            error: { type: Boolean, default: false },
        },
        emits: ['clear', 'retry'],
    };
</script>

<style scoped>
    .cert-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 8px;
        padding: 48px 20px;
        color: var(--certs-text, #111827);
    }

    .cert-empty__icon {
        width: 64px;
        height: 64px;
        margin-bottom: 8px;
        border-radius: 16px;
        display: grid;
        place-items: center;
        background: rgba(26, 196, 205, 0.12);
        color: #0f766e;
    }

    .cert-empty h2 {
        margin: 0;
        font-size: 1.15rem;
    }

    .cert-empty p {
        margin: 0;
        max-width: 420px;
        color: var(--certs-muted, #6b7280);
    }

    .cert-empty__btn {
        margin-top: 8px;
        min-height: 40px;
        padding: 0 16px;
        border: 1px solid var(--certs-line, #e8eaf0);
        border-radius: 8px;
        background: var(--certs-surface, #fff);
        color: var(--certs-text, #111827);
        font-weight: 600;
        cursor: pointer;
    }

    .cert-empty__btn:focus-visible {
        outline: 2px solid var(--certs-accent, #1ac4cd);
        outline-offset: 2px;
    }
</style>
